function buildPrice() {
      var extras = 0;

      if ($('.club-number-inputs').length > 0){
          var numberOfClubs = $('.club-number-inputs:checkbox:checked').length;
        } else {
        var numberOfClubs = 1;
        }
      $( ".extra" ).each(function( index ) {
        var selectedExtra = ($(this).val());

        if (selectedExtra == null || selectedExtra == "" && $(this).is('select')){
          var extraPrice = 0.00;
        } else {
          if ($(this).hasClass( "installFee" )){
            if ($(this).is(":checked")) {
             var extraPrice = $(this).data('price') * numberOfClubs; 
            } else {
            var extraPrice = 0; 
            }
            
          } else {
            if ($(this).children("option[value='" + selectedExtra + "']").length > 0) {
    var extraPrice = $(this).children('option[value="' + selectedExtra + '"]').data('price');
} else {
    var extraPrice = $(this).attr("data-price");
}
          
           
              
            var extraPrice = extraPrice.toString().replace(',', '.').replace(/\s/g, '');  
            
            var extraPrice = parseFloat(extraPrice);
            var extraPrice = extraPrice * numberOfClubs;   
         // console.log(extraPrice.toLocaleString("it-IT", {style:"currency", currency:"EUR"}));
          }
        }

        extras = extras + extraPrice;
      });

      var clubVariantPriceTotal = clubVariantPrice * numberOfClubs;
 
      var clubVariantCompareAtPriceTotal = clubVariantCompareAtPrice * numberOfClubs;
     if (clubVariantCompareAtPriceTotal == 0){
       var clubVariantCompareAtPriceIsZero = true;
     } else {
       var clubVariantCompareAtPriceIsZero = false;
     }
      
      var customPriceTotal = clubVariantPriceTotal + extras;

      var compareAtPriceTotal = clubVariantCompareAtPriceTotal + extras;
      var compareAtPriceTotalShopify = compareAtPriceTotal * 100;

      var customPriceTotalShopify = customPriceTotal * 100;
      let formattedCustomPriceTotal = Shopify && Shopify.formatMoney(customPriceTotalShopify, `${currency_symbol}{{amount}}`);
      let formattedCustomComparePriceTotal = Shopify && Shopify.formatMoney(compareAtPriceTotalShopify, `${currency_symbol}{{amount}}`);
  
      //let formattedCustomComparePriceTotal = compareAtPriceTotal.toLocaleString("de-DE", {style:"currency", currency:iso_code});
      //let formattedCustomPriceTotal = customPriceTotal.toLocaleString("de-DE", {style:"currency", currency:iso_code, currencyDisplay: "symbol"});

  if ($(".product-price-container .price del").html() == undefined){
        var currentPriceDisplay = $(".product-price-container .price").text();
          $(".product-price-container .price-inner").text(formattedCustomPriceTotal); 
        } else {
          $(".product-price-container .price ins span").text(formattedCustomPriceTotal); 
   if (clubVariantCompareAtPriceIsZero == true) {
     $(".product-price-container .price del span,.badge.onsale").hide();
   } else {
     $(".product-price-container .price del span").show();
   }
          $(".product-price-container .price del span").text(formattedCustomComparePriceTotal); 
          
        }
  //updating rewards points display
  if ($(".reward-points-amount").length > 0){
     if($(".birdie_tier").length > 0){
       var multiplier = 1.25;
     } else if ($(".eagle_tier").length > 0) {
       var multiplier = 1.5; 
     } else {
      var multiplier = 1;
     }



     if (productType == "Golf Balls"){
      var multiplier = 2;
     }

   
      $(".reward-points-amount").text(Math.floor(customPriceTotal * multiplier));
      if ($(".rewards-points-dollar-amount").length > 0){
        var rewardsValue = (customPriceTotalShopify * multiplier) * .05;
        $(".rewards-points-dollar-amount").text(Shopify && Shopify.formatMoney(rewardsValue, `${currency_symbol}{{amount_no_decimals}}`));   
       }

 }
   



}




const selectBox = document.querySelector('.select-box');

let currentShaftValue = null;
let currentShaftSku = null;
let currentGripValue = null;
let currentFerruleValue = $(".selected3").data("id");

var programmaticClick = false;


function shaftFiltering(shaftModel, isOriginalEvent){

   if (programmaticClick) return;

  $(".select-box").addClass("custom-loading");
  $(".shaftChoicesContainer .option").show();
  if ($("input[name='flex']").length){
   var shaftFlex = $("input[name='flex']:checked").val();     
  }
  

  if (productType === "Custom Iron Set" || productType === "Custom Wedge" || productType === "Custom Utility Iron"){
  var shaftMaterial = $('.material-radios input[name="radioMaterial"]:checked').val();
   // alert(shaftMaterial);
  } else {
    //is wood
   var shaftMaterial = "graphite";
  }
  var shaftBrandTitle = $(".shaftBrand option:selected").val();

  if (shaftBrandTitle != "Free Flex" && productType != "Custom Putter"){
    $(".shaftChoicesContainer .option").not("[data-flex='" + shaftFlex + "'][data-material='" + shaftMaterial + "']").hide();   
  } else {
    $(".shaftChoicesContainer .option[data-model='No Shafts Available In Chosen Flex']").hide();
  }

if ($("input[name='flex']").length && shaftBrandTitle != "Free Flex" && productType != "Custom Putter") {
  if ($(".shaftChoicesContainer .option[data-flex='" + shaftFlex + "'][data-material='" + shaftMaterial + "']").length === 0){
    //no shafts available in flex
    $(".option[data-flex='NA']").show();
    var firstItem = $(".option[data-flex='NA']").first();
    
  } else {
   var firstItem = $(".option[data-flex='" + shaftFlex + "'][data-material='" + shaftMaterial + "']").first();  
  }
  
} else {
  var firstItem = $(".option[data-material='" + shaftMaterial + "']").first();
}


  currentShaftValue = firstItem.data("value");
  currentShaftSku = firstItem.data("sku");
  var maxLength = firstItem.data("nolengths");
  filterLengths(maxLength);
  var shaftPrice = firstItem.data('price');
  $(".shaft-options").attr("data-price", shaftPrice);
  var titlePriceText = firstItem.find('.option-title-price').html();
  
  $(".selected").html(titlePriceText);

  if (shaftModel == "ff"){
    var shaftImage = shaftModel.image;
  } else { 
    var shaftImage = firstItem.find('.option-image img').attr('src');
  }
  
    $(".selectedShaftImage").attr("src", shaftImage);
  if (isOriginalEvent == undefined){
    //request is coming from shaft search - make timeout longer
    timeOut = 1100;
  } else {
    timeOut = 300
  }

  setTimeout(function() {
        $(".select-box").removeClass("custom-loading");
    }, timeOut);
  buildPrice();
  
  
}

$(".flex").change(function () {
  if (!programmaticClick) {
    programmaticClick = true;
    $("input.drawer-flex[value='" + $(this).val() + "']").prop("checked", true);
    programmaticClick = false;
  }
  shaftFiltering();
});

$(".drawer-flex").change(function () {
  if (!programmaticClick) {
    programmaticClick = true;
    $("input.flex[value='" + $(this).val() + "']").prop("checked", true);
    programmaticClick = false;
  }
  shaftFiltering();
});

///shaft choice click function

$('.shaftChoicesContainer .options').on('click', '.option', function(e) {


    currentShaftValue = $(this).data('value');
    currentShaftSku = $(this).data('sku');
    var titlePriceText = $(this).find('.option-title-price').html();
    var shaftPrice = $(this).data('price');
    $(".shaft-options").attr("data-price", shaftPrice);
    $(".shaftChoices .selected").html(titlePriceText);
  
    var maxLength = $(this).data("nolengths");
    filterLengths(maxLength);
  
    var shaftImage = $(this).find('.option-image img').attr('src');
    $(".selectedShaftImage").attr("src", shaftImage);
  
    $(".shaftChoicesContainer").removeClass("active");
    $("body").removeClass("open-cc");
  buildPrice();
});


function changeShaftBrandWithFlex2(chosenBrand, isOriginalEvent) {
  var handle = $(chosenBrand).find(':selected').data('handle');

  
  fetch(window.Shopify.routes.root + 'products/' + handle + '?view=data&type=' + productType)
    .then(response => response.json())
    .then(product => {
      var selectElement = $('.options');
      $(".options").html(""); // Clear existing options
      var flexCount = 0;
      var shaftFlex = $("input[name='flex']:checked").val(); // Get selected flex value
      var shaftModel;
      // Loop through product variants and create custom options
      $.each(product.variants, function(index, item) {
  
        if (index === 0){
         shaftModel = item;
        }
        // Skip "Fairway" shafts for drivers
        if (productType.includes("Driver") === true && item.title.includes("Fairway") === true) {
          return true; // Continue to the next variant
        }


        
        // Create the HTML structure for each option
        var optionElement = $('<div></div>').addClass('option option-flex')
          .attr({
            'style': 'align-items:center;',
            'data-value': item.id,
            'data-flex': item.flex,
            'data-brand': item.vendor.replace(/\s/g, ''), // Replace spaces in brand name
            'data-model': item.title,
            'data-sku': item.sku,
            'data-material': item.material,
            'data-price': item.price,
            'data-img': item.image,
            'data-attributes': item.attributes,
            'data-nolengths': item.no_lengths,
            'disabled': item.available === "false"
          })
          .append(`
            <div class="option-column-1">
              <div class="option-title-price option-flex">
                <span class="option-title">${item.title}</span>
                <span class="option-price"><span class="${item.compare_at_price ? `sale-price` : ''}">+${item.price_formatted}</span>${item.compare_at_price ? `<del style='margin-left:4px;opacity:.8'>+$${item.compare_at_price}</del> ` : ''}</span>
              </div>

              <div class="backorder">
                  ${item.backorder}
              </div>
              <div class="option-image">
                <img src="${item.image}" alt="${item.title}">
              </div>
              <div class="option-badges option-flex">
                
              </div>
            </div>
            <div class="option-column-2">
              <p class="option-characteristics">${item.characteristics }</p>
            </div>
          `);

      if (item.available == "false"){
        let badge = `<span class="option-badge">UNAVAILABLE</span>`;
        optionElement.find('.option-badges').append(badge);
      } else {
        $.each(item.attributes, function(index, attribute) {
  // Create the badge element
  let badge = `<span class="option-badge">${attribute}</span>`;
  let lowerCaseAttribute = attribute.toLowerCase();
  // Check if the attribute contains "NEW" and add the 'new' class
  if (lowerCaseAttribute.includes("new") || lowerCaseAttribute.includes("limited") || lowerCaseAttribute.includes("special")) {
    badge = `<span class="option-badge new">${attribute}</span>`;
  }
  // Append the badge to the option-badges container
  optionElement.find('.option-badges').append(badge);
});
      }
        // Append the created option to the select element
        selectElement.append(optionElement);

      
      });
      
shaftFiltering(shaftModel, isOriginalEvent);

      // You can handle any additional logic here (e.g., if no matching flexes found)
    });
}





 $('.shaftChoices').click(function(e) {
   $(".shaftChoicesContainer").addClass("active");
     $("body").addClass("open-cc");
 });


$('.gripChoices').click(function(e) {
   $(".gripChoicesContainer").addClass("active");
     $("body").addClass("open-cc");
 });

$('.ferruleChoices').click(function(e) {
   $(".ferruleChoicesContainer").addClass("active");
     $("body").addClass("open-cc");
 });


function changeGripBrand2(chosenGripBrand){
  $(".grip-options .option").hide();
  var gripBrand = $(chosenGripBrand).find(':selected').data('brand');
   if (productType == "Custom Putter" && $('.isCounterbalance').is(':checked')){
      var gripBrandFirstModel = $(".grip-options .option[data-brand='" + gripBrand + "'][data-putterbuild='Counterbalance']").first();
    } else {
      var gripBrandFirstModel = $(".grip-options .option[data-brand='" + gripBrand + "']").first(); 
    }
  
  currentGripValue = gripBrandFirstModel.data("value");
  if (productType == "Custom Putter" && $('.isCounterbalance').is(':checked')){
   $(".grip-options .option[data-brand='" + gripBrand + "'][data-putterbuild='Counterbalance']").show(); 
  } else {
    $(".grip-options .option[data-brand='" + gripBrand + "']").show(); 
  }
  

  var titlePriceText = gripBrandFirstModel.find('.option-title-price').html();

    $(".gripChoices .selected2").html(titlePriceText);
  
  var gripPrice = gripBrandFirstModel.data('price');
    $(".grip-options").attr("data-price", gripPrice);
  var gripImage = gripBrandFirstModel.find('.option-image img').attr('src');
    $(".selectedGripImage").attr("src", gripImage);
  buildPrice();

}


///grip choice click function

$('.gripChoicesContainer .grip-options').on('click', '.option', function(e) {
  
    currentGripValue = $(this).data('value');
  
    var titlePriceText = $(this).find('.option-title-price').html();
    var gripPrice = $(this).data('price');
    $(".grip-options").attr("data-price", gripPrice);
    $(".selected2").html(titlePriceText);
  
  
    var gripImage = $(this).find('.option-image img').attr('src');
    $(".selectedGripImage").attr("src", gripImage);
  
    $(".gripChoicesContainer").removeClass("active");
    $("body").removeClass("open-cc");
  buildPrice();
});


///ferrule choice click function

$('.ferruleChoicesContainer .ferrule-options').on('click', '.option', function(e) {
  
    currentFerruleValue = $(this).data('value');
   
    var titlePriceText = $(this).find('.option-title-price').html();
    var ferrulePrice = $(this).data('price');
    $(".ferrule-options").attr("data-price", ferrulePrice);
    $(".selected3").html(titlePriceText);

    var ferruleImage = $(this).find('.option-image img').attr('src');
    $(".selectedFerruleImage").attr("src", ferruleImage);
  
    $(".ferruleChoicesContainer").removeClass("active");
    $("body").removeClass("open-cc");
  buildPrice();
  console.log(currentFerruleValue);
});

function filterLengths(maxLength){
  if (maxLength){
      $(".clubLength option").each(function(){
        var value = parseFloat($(this).val());
        if (value > maxLength) {
            $(this).prop('disabled', true);
        }
    });
    } else {
      $(".clubLength option").prop('disabled', false);
    }
}




    $( document ).ready(function() {
   $(".best-arrow-prev svg").click(function() {
  var leftPos = $('.table-scroll').scrollLeft(); 
    $(".table-scroll").animate({
        scrollLeft: leftPos - 200
    }, 700);
  });
$(".best-arrow-next").click(function() {
  var leftPos = $('.table-scroll').scrollLeft();  
    $(".table-scroll").animate({
        scrollLeft: leftPos + 200
    }, 700);
  });
    });
$(document).ready(function(){
$(".openSpecs").click(function(){
  $(".specsPop, .specsOverlay").css("display","block").animate({opacity:1},200);
});
$(".openFlexRecs").click(function(){
  $(".flexPop, .flexOverlay").css("display","block").animate({opacity:1},200);
});
  $(".openSST").click(function(){
  $(".sstPop, .sstOverlay").css("display","block").animate({opacity:1},200);
});
$(".closeSpecs, .specsOverlay").click(function(){
  $(".specsPop, .specsOverlay,.sstPop, .sstOverlay, .flexPop,.flexOverlay").animate({opacity:0}).css("display","none");
});
$('.specsOverlay .specsPop').click(function(e){
   e.stopPropagation();
});
});
function gaAddToCartPush(productArray){
const cartItems = productArray.items;
const cleanedData = [];
const twitterData = [];
var gaValueTotal = 0;
// Loop through each item in the cartItems array
for (let i = 0; i < cartItems.length; i++) {
    const currentItem = cartItems[i];
    gaValueTotal = gaValueTotal + currentItem['final_line_price'];
    // Extract the relevant information
    const cleanedItem = {
        'id': currentItem['id'],
        'name': currentItem['product_title'],
        'brand': currentItem['vendor'],
        'category': currentItem['product_type'],
        'price': currentItem['final_price'] / 100,
        'quantity': currentItem['quantity'],
        'variant': currentItem['variant_title']
    };

  const twitterItem = {
        'content_type': 'Product',
        'content_id': currentItem['id'],
        'content_name': currentItem['product_title'],
        'content_price': currentItem['final_price'] / 100,
        'num_items': currentItem['quantity'],
        'content_group_id': currentItem['id']
    };

    // Add the cleaned item to the array
  if (currentItem['quantity'] > 0){
    cleanedData.push(cleanedItem);
    twitterData.push(twitterItem);
  }
  
}


      gtag('event', 'add_to_cart_custom', {
   'ecomm_prodid':  gaProductId,
    'ecomm_totalvalue': gaValueTotal / 100,
    'ecomm_pagetype': "cart",
    'ecomm_custom_add': "yes",
    'value': gaValueTotal / 100,
    'currency': 'USD',
    'items': cleanedData
});
  
/*
  twq('event', 'tw-ohxif-oj9rr', {
    contents: twitterData, 
    email_address: gaCustomer 
  });
  */
    }


function changeShaftWithURLParams(){

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const shaftSku = urlParams.get('shaft');
  const shaftmaterial = urlParams.get('material');
  if (shaftSku != "" && shaftSku != null) {
      const shaftVendorParameter = urlParams.get('vendor');
    if (shaftmaterial){
      $('.material-radios label[for="radioGraphite"]').click();
      var timeOut = 700;
      
    } else {
      var timeOut = 25;
    }
    setTimeout(function() {
  
      $('.shaftBrand option[data-brand="'+shaftVendorParameter+'"]').prop('selected', true);
      var shaftBrand = $(".shaftBrand").find(':selected').data('brand');
      $('.shaftBrand').change();
      var handle = $(".shaftBrand").find(':selected').data('handle'); 
           setTimeout(function() {
              var shaftFlex = $(".shaftChoicesContainer .options .option[data-sku='" + shaftSku + "']").data("flex");
              $('input[name="flex"][value="'+shaftFlex+'"]').click();
              var shaftID = $(".shaftChoicesContainer .options .option[data-sku='" + shaftSku + "']").data("value");
              $('.shaftChoicesContainer .options .option[data-value="'+shaftID+'"]').click();

          }, 800);
    }, timeOut);
      }

    }